<template>
  <div class="main-init">
    <PortraitPromptPanel />
    <OfflineWarningPanel />
    <BrowserWarningPanel
      v-if="showBrowserWarning"
      @close="showBrowserWarning = false"
    />
  </div>
</template>


<script>
import EventBus from "../eventBus";
import PortraitPromptPanel from "@/components/PortraitPromptPanel.vue";
import OfflineWarningPanel from "@/components/OfflineWarningPanel.vue";
import BrowserWarningPanel from "@/components/BrowserWarningPanel.vue";

import {
  getMobileOS,
  isStandalone,
  isWebview,
  hasCameraAccess,
} from "../functions.js";

export default {
  components: {
    PortraitPromptPanel,
    OfflineWarningPanel,
    BrowserWarningPanel,
  },
  data() {
    return {
      isOffline: false,
      showBrowserWarning: false,
      width: 0,
    };
  },
  computed: {},
  activated() {},
  mounted() {
    // this.offline(); // testing only
    this.width = window.innerWidth;
    // this.console("window.location.origin", window.location.origin);

    this.handle100vhIssue();
    setTimeout(() => this.checkWindowSize(), 500);
    this.$nextTick(() => this.watchWindowResize());

    this.$cookies.set("referrer", document.referrer); // seems this will be null
    this.$cookies.set("app_load_at", new Date().toLocaleTimeString());

    // this.checkLanguage();
    this.monitorOnlineStatus(); // watches online/offline events

    EventBus.$on("HAS_CAMERA", (hasCamera) => {
      this.$store.commit("setCameraState", hasCamera);
    });
    hasCameraAccess((hasCamera) => EventBus.$emit("HAS_CAMERA", hasCamera));

    EventBus.$on("LOGOUT", () => {
      this.$swal({
        title: "Logged out!",
        text: "Automatically reloading...",
        showConfirmButton: false,
      });
      setTimeout(() => location.reload(), 500);
    });
    EventBus.$on("LINE_LOGIN_SUCCESS", (userData) => {
      this.$cookies.set("line_user", userData);
      this.console("line_user", this.$cookies.get("line_user"));
    });

    // not used currently, might need in some markets
    // EventBus.$on("TRIGGER_PWA_PROMPT", () => this.installPWA());

    var speed = 0; // network speed, not supported for iOS
    if (navigator.connection) speed = navigator.connection.downlink;

    this.$store.commit("setDevice", {
      os: getMobileOS(),
      browser: this.$browserDetect.meta.name,
      isSafari: this.$browserDetect.isSafari,
      userAgent: this.$browserDetect.meta.ua,
      pwa: isStandalone(),
      webview: isWebview(),
      language: this.checkLanguage(), // this is browser language, not TUK app language
      iOSApp: this.isIOSApp(),
      api_latency: this.$store.state.systemSpeed,
      network_speed: speed,
      cpu_benchmark: this.$store.state.cpuBenchmark,
      referrer: document.referrer,
      start_url: window.location.href,
      ad_tag: this.extractAdTag() || this.$store.getters.getAdTag,
      height: window.innerHeight,
      width: window.innerWidth,
      referral_code: this.extractReferralCode(),
      ip_address: this.$store.state.ipAddress, // will be null first time
      storage: this.$store.state.storage,
      storage_persisted: this.$store.state.storagePersisted,
      notification_token: this.$store.state.notificationToken,
      last_notification: this.$store.state.notification,
    });

    console.log("setDevice", this.$store.state.device);

    // this only sets uuid if not yet set
    this.$store.commit("setUUID", {
      uuid: this.newUUID(),
      createdAt: new Date(),
    });

    this.$store.dispatch("saveDevice", this.golangTimestamp());

    this.checkLangQuery();
    this.$nextTick(() => {
      if (this.$store.state.language) {
        this.setLang(this.$store.state.language, false);
      } else {
        this.log("device_language", this.$store.getters.getDeviceLanguage);
        this.setLang(this.$store.getters.getDeviceLanguage, false);
        setTimeout(() => this.openLanguageSelector(), 1500);
      }
    });

    EventBus.$on("PORTRAIT_PROMPT", () => {
      this.showComponent(".portrait-prompt-panel-component");
    });

    this.getIPAddress(); // only does this once and stores in localStorage
    this.checkStorage();
    setTimeout(() => this.checkBrowser(), 10000);

    // window.addEventListener("message", (event) => {
    //   console.log("SW msg", event, event.data);
    // });

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.onmessage = (e) => {
        console.log("SW message", e.data);
        this.$store.commit("newNotification", e.data);
      };
    }
  },
  methods: {
    getIPAddress() {
      if (this.$store.state.ipAddress) return; // do it only once and store it
      this.$store
        .dispatch("getIPAddress") // 1. gets IP address, 2. looks it up
        .then((res) => {
          this.log("ip_address", res.data);
          console.log("IP Address", res.data);
          this.$store.dispatch("saveDevice", this.golangTimestamp()); // save device again now that have IP address
        })
        .catch((err) => {
          this.log("ip_address_error", err);
        });
    },
    checkStorage() {
      if (navigator.storage && navigator.storage.estimate) {
        // quota.usage (Number of bytes used), quota.quota (Maximum number of bytes available)
        navigator.storage.estimate().then((quota) => {
          const percentageUsed = (quota.usage / quota.quota) * 100;
          const remaining = quota.quota - quota.usage;
          var data = {
            percent_used: percentageUsed,
            bytes: remaining,
            kb: Math.round(remaining / 1024),
            mb: Math.round(remaining / (1024 * 1024)),
            gb: Math.round(remaining / (1024 * 1024 * 1024)),
          };
          console.log("storage", data);
          this.$store.commit("setStorage", data);
        });
      }
      // Check if site's storage has been marked as persistent
      if (navigator.storage && navigator.storage.persist) {
        navigator.storage.persisted().then((isPersisted) => {
          console.log(`storage persisted: ${isPersisted}`);
          this.$store.commit("setStoragePersisted", isPersisted);
        });
      }
    },
    handle100vhIssue() {
      var intervalID = setInterval(() => {
        window.setViewportProperty(document.documentElement);
      }, 1500);
      setTimeout(() => clearInterval(intervalID), 15000);
    },
    checkBrowser() {
      if (!this.$store.getters.isWorker) return;
      // this.showBrowserWarning = true;
      var isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
      if (isSamsungBrowser) this.showBrowserWarning = true;
    },
    extractAdTag() {
      // made this func because this.$route.query.a was not working here
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      console.log("extractAdTag", queryString, urlParams, urlParams.get("a"));
      return urlParams.get("a");
    },
    extractReferralCode() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      if (urlParams.get("rc")) {
        var msg = `🏷 Referral Code Click [ ${urlParams.get("rc")} ]`;
        this.sendSuperuserNotification(msg);
      }
      return urlParams.get("rc") || this.$store.getters.getReferralCode;
    },
    dismissOverlay() {
      EventBus.$emit("PORTRAIT_PROMPT", false);
    },
    showOverlay() {
      setTimeout(() => EventBus.$emit("PORTRAIT_PROMPT", true), 5000);
    },
    watchWindowResize() {
      window.addEventListener("resize", () => {
        this.$store.commit("updateScreenSize");
        if (this.width == window.innerWidth) {
          this.console("resize same width", this.width);
          return;
        }
        this.width = window.innerWidth; // width changed
        if (window.innerWidth < 500) return; // mobile split screen hack
        if (window.innerHeight > 500) return; // desktop hack
        if (window.innerHeight < window.innerWidth) {
          this.showOverlay();
        } else {
          this.dismissOverlay();
        }
      });
    },
    checkWindowSize() {
      // old hacky function that used to redirect to web.tukapp.co
      // some kind of mobile in portrait mode, so it's okay (fix ios FB issue)
      if (window.innerWidth < 500) return; // mobile split screen hack
      if (window.innerHeight > 500) return; // desktop hack

      // var baseURL = window.location.origin;
      var query = this.$route.query; // check for app
      if (query.app == "true") return; // force to app if true
      // if (
      //   !baseURL.includes("app.tukapp.co") &&
      //   !baseURL.includes("localhost") &&
      //   !isStandalone()
      // ) {
      if (window.innerWidth > window.innerHeight) {
        this.showOverlay(); // overlay screen while redirecting
      }
    },
    checkLanguage() {
      var language =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage;
      return language;
    },
    dismissOfflineWarning() {
      this.isOffline = false; // should keep offline state in store so can show on home page panel
    },
    monitorOnlineStatus() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setInternetState") {
          if (this.$store.state.hasInternet) this.online();
          else this.offline();
        }
      });
      window.addEventListener("online", () => this.online());
      window.addEventListener("offline", () => this.offline());
    },
    online() {
      EventBus.$emit("OFFLINE_WARNING", false);
      this.isOffline = false;
    },
    offline() {
      this.showComponent(".offline-warning-panel-component");
      EventBus.$emit("OFFLINE_WARNING", true);
      this.isOffline = true;
    },
    webRedirectAlert() {
      // not being used at the moment
      this.console("overlay", document.getElementById("overlay"));
      this.showOverlay();
      this.$swal({
        title: "TUK Web Redirect",
        html: `Please view the TUK App on mobile
        <br><br><i>Redirecting in 3 seconds...</i>`,
        timer: 3000,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Go to web",
        cancelButtonText: "Stay on app",
      }).then((result) => {
        this.console("dismiss reason", result.dismiss);
        if (result.dismiss === "cancel") {
          this.console("Cancelled web redirect");
          this.dismissOverlay();
          return; // stay on page
        }
        this.console("Redirecting to web");
        window.location = "https://web.tukapp.co";
      });
    },
  },
};
</script>

<style scoped>
</style>